import './Header.css'

export default function Header() {
  return (
    <div className="header">
      <div className="socials">
        {/* TODO add icons */}
        <a href="https://github.com/JDNafz">Github</a>
        <a href="https://linkedin.com/in/jdnafziger">Linkedin</a>
      </div>
    </div>
  );
}
